import React from "react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml, FONT } from "./_shared";
import { useBul } from "./BulLayout";

export default function About() {
  const data = useBul();
  const trust = data.trust || {};
  return (
    <div data-testid="bul-about">
      <PageHero eyebrow="Our Story" title="About the Institute" />
      <PageBody>
        <div className="grid md:grid-cols-2 gap-12">
          <article className="bg-white p-10 border-l-4 border-[#FDBB30]">
            <div className="flex items-start gap-4">
              {trust.logo_url && (
                <img
                  src={trust.logo_url}
                  alt={trust.trust_name || "GSM"}
                  data-testid="bul-about-trust-logo"
                  className="w-16 h-16 object-contain bg-[#F8F5EE] p-1 shrink-0"
                  loading="lazy"
                />
              )}
              <div>
                <h2 className="text-2xl text-[#0F0F10]" style={{ fontFamily: FONT.serif, fontWeight: 700 }}>
                  Gramaudyogik Shikshan Mandal
                </h2>
                {trust.registration_number && (
                  <div className="mt-1 text-[10px] tracking-[0.3em] uppercase text-[#726C61] font-semibold">
                    Reg. No · {trust.registration_number}
                  </div>
                )}
              </div>
            </div>
            <p className="mt-6 text-[#2A2A2B] leading-[1.9] text-[15px]">{STATIC_CONTENT.about_gsm}</p>
          </article>
          <article className="bg-white p-10 border-l-4 border-[#0F0F10]">
            <h2 className="text-2xl text-[#0F0F10]" style={{ fontFamily: FONT.serif, fontWeight: 700 }}>
              {data.institute?.name || "About the Institute"}
            </h2>
            <div
              className="mt-6 text-[#2A2A2B] leading-[1.9] text-[15px] prose prose-sm max-w-none"
              data-testid="bul-about-institute"
              dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.about_institute || "").trim() || STATIC_CONTENT.about_mit) }}
            />
          </article>
        </div>
      </PageBody>
    </div>
  );
}
